import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-swatch-set.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import tailwindThemeConfig from '../../../resolved-tailwind-config';
// const outline = require('../outline.config');
import '../../base/outline-grid/outline-grid';
import '../../base/outline-grid/outline-column/outline-column';
import '../idb-swatch/idb-swatch';

export const IdbSwatchSets = [
  'blue-responsible',
  'gray-professional',
  'cyan-near',
  'green-guarantee',
  'gray-cosmopolitan',
  'green-quality',
  'yellow-knowledge',
  'orange',
  'purple-new',
  'neutral',
  'ui',
  'demo',
] as const;
export type SwatchSet = typeof IdbSwatchSets[number];

export interface IdbSwatchSetInterface extends HTMLElement {
  set: SwatchSet;
}

/**
 * Color swatch set
 *
 * @element idb-swatch-set
 */
@customElement('idb-swatch-set')
export class IdbSwatchSet
  extends OutlineElement
  implements IdbSwatchSetInterface
{
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  set: SwatchSet = 'blue-responsible';

  render(): TemplateResult {
    const colors = Object.entries(tailwindThemeConfig.colors[this.set]).map(
      ([name]) => name
    );

    return html`
      <outline-grid>
        ${colors.map(
          color => html`
            <outline-column col-span-default="12">
              <idb-swatch set="${this.set}" color="${color}"></idb-swatch>
            </outline-column>
          `
        )}
      </outline-grid>
    `;
  }
}
